import { Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

// Used to determine the type of device value is 'true' then display size is - 768 px.
@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  private readonly mobileQuery = '(max-width: 768px)';

  public readonly isMobile$: Observable<boolean> = this.breakpointObserver.observe([this.mobileQuery]).pipe(
    map((state: BreakpointState) => {
      return state.matches;
    }),
    shareReplay(1)
  );

  constructor(private breakpointObserver: BreakpointObserver) {}
}
